import { render } from "./ThanksPageEditContent.vue?vue&type=template&id=2c89f9c8&ts=true"
import script from "./ThanksPageEditContent.vue?vue&type=script&lang=ts"
export * from "./ThanksPageEditContent.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/hanlab/Downloads/remote2/10_waaq/1_Code_with_waaq/assistant/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__